export const bim = {
  addBim: "Agregar BIM",
  progressHelp:
    "Los archivos deben ser procesador para su visualización, este proceso puede tomar varios minutos.",
};
